import React, { Component } from "react";
import axios from "axios";
import $ from "jquery";
import Headers from "../Layouts/Headers";

import { MDBDataTable } from "../_mdbcomponents/components/DataTable/DataTable";


export class SearchInModule extends Component {
  constructor(props) {
    super(props);

   

    
    this.state = {
      visitid: "",
      DataLoaded: false,
      loaded: false,
    };

    this.handleChange = this.handleChange.bind(this);
    
  }




  handleRowClick(patient) {
    $(".patientDetails").show();
    $(".startTreatment").attr("id", patient.visitid);
    var details =
      patient.Name + " (" + patient.Age + ")- " + patient.Nationality;
    $(".patientName").text(details);
    var visitId = patient.visitid.split("_");
    var serialNumber = visitId[1];
    var visitNumber = visitId[2];

    $(".NumberOfVisit").text(visitNumber);
    $(".SerialNumber").text(serialNumber);

    }

  componentDidMount() {
    $(".patientDetails").hide();
    $(".startTreatment").on("click", function () {
      var visitId = $(this).attr("id");
        console.log(localStorage.getItem("currentModule"))

      localStorage.setItem("currentVisitId", visitId);
      const headers = {
        "Content-Type": "application/json",
        token: localStorage.getItem("accessToken"),
        visitid: visitId,
      };
    
      axios.get(this.api_url+"reception/onepatient", { headers: headers })
        .then((res) => {
        

          localStorage.setItem("currentVisitName", res.data[0]["Name"]);
          localStorage.setItem(
            "currentVisitNationality",
            res.data[0]["Nationality"]
          );
          localStorage.setItem(
            "currentVisitProfession",
            res.data[0]["Profession"]
          );
          localStorage.setItem("currentVisitAge", res.data[0]["Age"]);
          $('.alert-success').show();
          
          if(localStorage.getItem("currentModule") =="triage"){
            if (localStorage.getItem("currentSpecialty") == "nurse") {
              window.location.href = "/general/observations";
            } else {
              window.location.href = "/triage/init/dashboard";
            }
          }
          else if(localStorage.getItem("currentModule") =="gynecology"){

            window.location.href = "/history/taking";

          }
          else if(localStorage.getItem("currentModule") =="gynecology2"){
            window.location.href = "/history/taking";
          }
          else if(localStorage.getItem("currentModule") == 'lab')
          {
            window.location.href = "/lab/tests/requested"
          }
          else if(localStorage.getItem('currentModule') == 'labour')
          {
            window.location.href = "/labour/partograph";
          }
          else if(localStorage.getItem('currentModule') == 'delivery')
          {
            window.location.href = "/delivery/general";
          }
          else if(localStorage.getItem('currentModule') == 'theatre')
          {
            window.location.href = "/theatre/operating/delivery";
          }
          else if(localStorage.getItem('currentModule') == 'Post-natal')
          {
            window.location.href = "/post/natal/monitoring/form";
          }
          else if(localStorage.getItem('currentModule') == 'newborn')
          {
            window.location.href = "/newbornunit/newborn/demographic/data";
          }
        })
        .catch((error) => {
          console.log(error);
        });

    
    });

    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
    };
    axios.get(this.api_url+"billing/status/"+localStorage.getItem("currentModule")+"/open", { headers: headers })
      .then((res) => {
       
        var tableinit = new Array();
        for (var i = 0; i < res.data.length; i++) {
          
          if (res.data[i]["status"] == true) {
           
            if (res.data[i]["module"] == localStorage.getItem("currentModule")) {
              if (res.data[i]["modulestatus"] == "open") {
                if (
                  res.data[i]["modulestatus"] == "open" ||
                  res.data[i]["modulestatus"] == "pending"
                ) {
                  if (res.data[i]["paymentsstatus"] !== null) {
                    var number = i + 1;
                   
                    var split = res.data[i]["timeofopen"].split(" ");
                    var date = split[0];
                    var time = split[1];

                    tableinit.push(res.data[i]);

                    
                    let object = {};
                    for (let i = 0; i < tableinit.length; i++) {
                      delete tableinit[i]._id;
                      delete tableinit[i].timeOfRegistration;
                      tableinit[i].clickEvent = () =>
                        this.handleRowClick(tableinit[i]);
                    }
                    // table = JSON.stringify(table);
                    var visitId = res.data[i]["visitid"].split("_");
                    var visitNumber = { visitNumber: visitId[2] };
                    var serialNumber = { serialNumber: visitId[1] };

                    var table = Object.assign(
                      tableinit,
                      visitNumber,
                      serialNumber
                    );

                 
                    this.TableData = table;
                   
                    this.setState({
                      DataLoaded: true,
                    });

                    // var searchRow = '<tr><td>'+number+'</td> <td>'+res.data[i]['Name']+'</td><td>'+res.data[i]['Age']+'</td><td>'+res.data[i]['Profession']+'</td><td>'+res.data[i]['MaritalStatus']+'</td><td>'+res.data[i]['Address']+'</td><td>'+res.data[i]['Tel ']+'</td><td>'+res.data[i]['Nationality']+'</td><td>'+date+'</td><td>'+time+'</td><td>'+visitNumber+'</td><td>'+serialNumber+'</td><td></td><td></td><td><a className="btn btn-primary startTreatment" id="'+res.data[i]['visitid']+'">Start Treatment</a></td></tr>'
                    // $('.searchClass').append(searchRow)
                  }
                }
              }
            }
          }
        }

        //   if(res.data['status'])
        //   {
        //     $('.sendModuleSuccess').show()
        //     setTimeout(function (props) {
        //         $('.modal').hide()
        //          // this.props.history.push('/reception/dashboard')
        //      }, 3000);
        //   }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  render() {
    // Complications = request.json["Complications"],
    // PregnancyDate = request.json["PregnancyDate"],
    // EvolutionAndTreatment = request.json["EvolutionAndTreatment"],

    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const { Complications, PregnancyDate, EvolutionAndTreatment } = this.state;

    let { DataLoaded } = this.state;
    const tabledata = {
      columns: [
        {
          label: "Name",
          field: "Name",
          sort: "asc",
          width: 50,
        },
        {
          label: "Age",
          field: "Age",
          sort: "asc",
          width: 50,
        },
        {
          label: "Profession",
          field: "Profession",
          sort: "asc",
          width: 50,
        },
        {
          label: "Marital Status",
          field: "MaritalStatus",
          sort: "asc",
          width: 50,
        },
        {
          label: "Address",
          field: "Address",
          sort: "asc",
          width: 50,
        },
        {
          label: "Mobile Phone Number",
          field: "Tel ",
          sort: "asc",
          width: 50,
        },
        {
          label: "Nationality",
          field: "Nationality",
          sort: "asc",
          width: 50,
        },

        {
          label: "Date and Time Sent From Reception",
          field: "timeofopen",
          sort: "asc",
          width: 50,
        },
        {
          label: "Status",
          field: "modulestatus",
          sort: "asc",
          width: 50,
        },
        {
          label: "Payment Status",
          field: "paymentsstatus",
          sort: "asc",
          width: 50,
        },
      ],
      rows: this.TableData,
    };
  
    return (
      <div>
        <Headers />

        <main>
          <div className="container p-2">
            <form>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}></p>
                </div>
                <MDBDataTable striped bordered data={tabledata} />
              </div>
            </form>
          </div>
        </main>
        <div className="modal patientDetails" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title patientName"> </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>
                  Number Of Visit: <span className="NumberOfVisit"></span>
                </p>
                <p>
                  Serial of Number: <span className="SerialNumber"></span>
                </p>
                <br/>
                <button className="btn btn-success startTreatment">
                  Start Treatment
                </button>
                <div
                  id="loginSuccess"
                  className="alert alert-success"
                  style={displayHidden}
                  role="alert"
                >
                  <strong>Success! </strong>Treatment Started Successfully
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SearchInModule;
